<template>
  <div>
    <div
      class="card !border-none !p-1 m-0 !h-[calc(100vh-150px)] overflow-y-auto !bg-transparent"
      style="width: 100%"
      v-loading="loading"
      element-loading-text="Loading..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <h3 class="text-black-950 !font-normal text-sm 2xl:!text-base !m-0 !pb-4">
        Transfer Account Ownership
      </h3>

      <el-form
        :model="ruleForm"
        label-position="top"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <div class="!p-3 !border border-black/10 rounded-xl">
          <p class="text-black-950 !font-normal text-sm 2xl:!text-base !m-0 !pb-4">
            Your account is currently associated with
            <span class="!text-brand-500">{{ getAuthenticatedUser.email }}</span>
            . To initiate a transfer, simply fill out the form and authenticate both accounts. Once
            completed, your account assets will be ready for transfer.
          </p>
          <el-form-item prop="email" class="!mb-4">
            <span class="text-[#383838] text-xs xl:text-[13px] 2xl:text-sm font-normal block !mb-1">
              <span class="!text-[#EB5757]">*</span>
              New Account Email
            </span>
            <el-input v-model="ruleForm.email"></el-input>
          </el-form-item>
        </div>
        <!-- <el-form-item label="Resources" prop="resource">
                      <el-radio-group v-model="ruleForm.resource" size="mini">
                        <el-radio-button value="OnlyThisWorkspace" label="Only This Workspace"></el-radio-button>
                        <el-radio-button value="AllWorkspaces" label="All Workspaces"></el-radio-button>
                      </el-radio-group>
                    </el-form-item> -->
        <el-form-item class="!mt-6">
          <el-button
            style="background: var(--brand-500) !important"
            class="!text-white !border-brand-500 !px-5 !py-2.5 !rounded-md text-xs 2xl:text-mds"
            type="button"
            @click="submitForm('ruleForm')"
            size="mini"
          >
            Transfer
          </el-button>
          <button
            @click="resetForm('ruleForm')"
            size="mini"
            class="bg-transparent border hover:text-brand-500 hover:!border hover:!border-brand-500 text-black-700 !px-5 !py-1.5 !rounded-md !border-black-500 text-xs 2xl:text-mds !ml-2"
          >
            Reset
          </button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Swal from 'sweetalert2';
  import SysAxios from '@/config/axios';
  import appConfig from '@/config/app';
  export default {
    name: 'Dashboard-Stats',
    async mounted() {
      this.loading = true;
      // await this.fetchUserdashboardStatics();
      // await this.setData();
      this.loading = false;
    },
    computed: {
      ...mapGetters('auth', ['getAuthenticatedUser', 'getActiveWorkspace']),
      ...mapGetters('settings', [
        'getUserDashboardStastics',
        'getUpdateUserDashboardStaticsStatus',
      ]),
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log(this.ruleForm);
            let inputValue = '';
            Swal.fire({
              title: 'Authentication',
              input: 'password',
              inputLabel: 'Please enter your password',
              inputPlaceholder: 'Please enter your password',
              inputValue,
              inputAttributes: {
                autocapitalize: 'off',
              },
              confirmButtonText: 'Transfer',
              showLoaderOnConfirm: true,
              showCancelButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              inputValidator: (value) => {
                if (!value) {
                  Swal.hideLoading();
                  return 'Invalid Password';
                }
                let valid =
                  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/.test(
                    value
                  );
                if (!valid) {
                  Swal.hideLoading();
                  return 'Must have one Uppercase(A-Z) letter,one lowercase(a-z) letter ,one number(0-9) and one symbol';
                }
              },
              preConfirm: async (value) => {
                try {
                  let payload = { ...this.ruleForm, key: value };
                  let response = await SysAxios.post('/transferOwnership', payload);
                  Swal.fire({
                    icon: 'success',
                    title: '',
                    text: 'OTP has been sent to both email ids',
                    confirmButtonText: 'Ok',
                    showLoaderOnConfirm: true,
                    showCancelButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                  }).then(() => {
                    this.$router.push({
                      name: 'AppOwnerTransferOTPAuth',
                      params: { requestId: response.data.referenceId },
                    });
                  });
                } catch (err) {
                  console.log(err);
                  Swal.showValidationMessage(err.response.data.message || err.message);
                }
              },
            }).then((result) => {
              console.log(result);
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    },
    data() {
      return {
        loading: false,
        serverBaseURL: appConfig.AUTHFAST_BASE_URL,
        ruleForm: {
          email: '',
          resource: 'OnlyThisWorkspace',
        },
        rules: {
          email: [
            {
              required: true,
              message: 'Please input email address',
              trigger: 'blur',
            },
            {
              type: 'email',
              message: 'Please input correct email address',
              trigger: ['blur', 'change'],
            },
          ],
          resource: [
            {
              required: true,
              message: 'Please select activity resource',
              trigger: 'change',
            },
          ],
        },
      };
    },
  };
</script>

<style lang="scss" scoped>
  .side-menu {
    height: 580px;
    scrollbar-width: thin;
    border-top: 1px ridge;
    border-left: 1px ridge;
    border-bottom: 1px ridge;
    margin-right: 5px;
  }
  .side-menu::-webkit-scrollbar {
    width: 0.7em;
  }
  .side-menu::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    background: #e1e1e1;
    -webkit-box-shadow: inset 0 0 6px rgba(172, 169, 169, 0.9);
  }
  .side-menu::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #f5f5f5;
    background-color: #f5f5f5;
  }
  .stats-list {
    .single-stat {
      padding: 1em 1.5em;
    }
    .stat-item:last-child {
      .stat-divider {
        display: none;
      }
    }
  }
  .el-button--mini {
    font-size: 14px;
    font-weight: 500;
  }
</style>
